import React from "react";
import "./styles.css";

function index() {
  return <div></div>;
}

export default index;
